import { render, staticRenderFns } from "./stadiums.vue?vue&type=template&id=2e09f404&"
import script from "./stadiums.vue?vue&type=script&lang=ts&"
export * from "./stadiums.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports